/**
 * An account in WalletConnect follows the CAIP-10 standard
 * and is formatted as follows:
 *
 * `<namespace>:<chain>:<address>`
 *
 * Where:
 * - `<namespace>` is the namespace key (e.g. "eip155")
 * - `<chain>` is what we refer to as a network ID (e.g. "1")
 * - `<address>` is the address of the account (e.g. "0x1234567890")
 *
 * See docs: https://github.com/ChainAgnostic/CAIPs/blob/main/CAIPs/caip-10.md
 *
 * @returns An object with the address, namespace key, and network id
 */
export const splitCaip10Token = (caip10Token: string) => {
  const [namespaceKey, networkId, address] = caip10Token.split(':');
  return { address, namespaceKey, networkId };
};
